import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { ImpactDataItem } from '../modules/widget/services/chart-report/chart-report-impact/chart-report-impact';

@Pipe({
  name: 'areaTooltip',
  standalone: false,
})
export class AreaTooltipPipe implements PipeTransform {
  transform(value: ImpactDataItem): unknown {
    const impactScore = (value.leftScore ?? value.rightScore).toFixed(2);
    return `${value.labelDisplay}\n${translate('widgets.impact-score', {
      score: impactScore,
    })}\n${translate('widgets.charting.tooltip.count-part-material', {
      count: value.documentCount,
    })}`;
  }
}
